import React  from "react";
import { useSelector } from "react-redux";


import { useContrats } from "../../state/reactquery";
import {useUser} from "../../state/reactquery";

import CardFormuleContrat from '../../Components/Contrats/CardFormuleContrat';


import './ListeContrats.scss'

function ListeContrats({ecran}){

    const ficheclient = useSelector(state=>state.lead.leadactu);
    const {data: user} = useUser(localStorage.getItem('token'))  ;
    const {data: contrats} = useContrats(ficheclient?.email,user?.courtier) ; 

   
    function filter_encours(etat){   return etat==='encours' || etat?.includes('impaye') }
    function filter_autre(etat){   return etat!=='projet' && etat!=='encours' && !etat?.includes('impaye') && !etat?.includes('resilie') && !etat?.includes('attente') }

    const contratsencours = contrats?.filter(x=>filter_encours(x.etat_contrat))?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );
    const contratsprojets = contrats?.filter(x=>  x.etat_contrat==='projet' )?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );
    const contratattentesignature = contrats?.filter(x=>x.etat_contrat==='attentesignature')?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );
    const contratsattentedocuments = contrats?.filter(x=>  x.etat_contrat==='attentedocuments' )?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );
    const contratsresilies = contrats?.filter(x=>x.etat_contrat?.includes('resilie'))?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );
    const contratsautres = contrats?.filter(x=>filter_autre(x.etat_contrat))?.sort((a,b)=>(new Date(b.date_insert)).getTime()  - (new Date(a.date_insert)).getTime()  );


    return(<>{(ecran!=='ecrangestiononeclient' && contratsprojets?.length >0) && <><div className="contrats_section_titre" >Contrat(s) en projet</div>
                                                        {contratsprojets?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}  /> )} </>  } 

            {contratattentesignature?.length >0 && <><div className="contrats_section_titre" >Contrat en attente de signature</div>
                                                            {contratattentesignature?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}  /> )} </>  } 
            {contratsattentedocuments?.length >0 && <><div className="contrats_section_titre" >Contrat en attente de documents</div>
                                                             {contratsattentedocuments?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}  /> )} </>  } 


            {contratsencours?.length >0 && <><div className="contrats_section_titre" >Contrat en cours</div>
                                                        {contratsencours?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}   /> )} </>  } 
        

            {contratsresilies?.length >0 && <><div className="contrats_section_titre" >Contrats Résiliés </div>
                                                        {contratsresilies?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}   /> )} </>  }

            {contratsautres?.length >0 && <><div className="contrats_section_titre" >Autres contrats</div>
                                                        {contratsautres?.map(contrat=><CardFormuleContrat key={contrat.indexe}  contrat={contrat} ecran={ecran}   /> )} </>  } 
         </>)


}



export default ListeContrats